// extracted by mini-css-extract-plugin
export default {"container":"sideMenu_container__yd4KQ","item":"sideMenu_item__Ih6ax","active":"sideMenu_active__8A5VP"};